import '@chekin/guestapp-ui-kit/global.css';
import React from 'react';
import {StyleSheetManager} from 'styled-components';
import {LocalStorage} from '@guestapp/core';
import ChekinProSettings from './ChekinProSettings';
import {CHEKIN_ROOT_IFRAME_ID, SDK_STYLES_LINK, SDK_STYLES} from './utils/embedded';
import App from './App';
import Frame from './components/Frame';
import {EmotionStyleSheetProvider} from './context/emotionStyleSheet';
import {FrameContextConsumer} from './context/frame';
import {InjectingStylesProvider} from './providers/InjectingStylesProvider';

function SDKApp() {
  const styles = LocalStorage.get(SDK_STYLES);

  React.useEffect(() => {
    LocalStorage.remove(SDK_STYLES);
    LocalStorage.remove(SDK_STYLES_LINK);
  }, [styles]);

  return (
    <Frame
      title={__APP_NAME__}
      name="chekin-pro-frame"
      role="application"
      id={CHEKIN_ROOT_IFRAME_ID}
      style={{
        border: 'none',
        overflow: ChekinProSettings.autoHeight ? 'hidden' : 'initial',
      }}
    >
      <FrameContextConsumer>
        {({document}) => (
          <StyleSheetManager target={document?.head}>
            <EmotionStyleSheetProvider target={document?.head}>
              <InjectingStylesProvider
                customStyles={window.ChekinProSettings.styles}
                customStylesLink={window.ChekinProSettings.stylesLink}
              >
                <App />
              </InjectingStylesProvider>
            </EmotionStyleSheetProvider>
          </StyleSheetManager>
        )}
      </FrameContextConsumer>
    </Frame>
  );
}

export default SDKApp;
